import { createContext, useContext } from 'react'
import { BuyMasterPayload, OrderOtpState, InvestPaymentMethodType } from '../../types/mf-execution.types'
import { OTPVerificationState, OTPVerificationHandlers } from '../../types/otp.types'
import { InstalledUpiApp } from '../../utils/installedUpiIntents'
import { AmountAdjustmentReason } from '../../utils/mf-execution/paymentAmount'

interface BuyContextType {
  buyMasterPayload: BuyMasterPayload
  handleBuyMasterPayload: (payload: BuyMasterPayload) => void
  isBuyOTPVerified: boolean
  handleBuyOTPVerification: (otp: string) => void
  otpVerificationState: OTPVerificationState
  otpVerificationHandlers: OTPVerificationHandlers
  amount: number
  /** Amount the screen opened with. Null when the field opened empty. */
  initialShownAmount: number | null
  handleAmountChange: (amount: number) => void
  fromAdvisory: boolean
  fromApp: boolean
  amountAdjustmentReason: AmountAdjustmentReason
  clearAmountAdjustmentReason: () => void
  paymentMethods: InvestPaymentMethodType[] | undefined
  bankAccountDetails: InvestPaymentMethodType[] | undefined
  defaultPaymentMethodDetails: InvestPaymentMethodType | null | undefined
  upiIntentMaximumAllowedAmount: number
  selectedPaymentMethod: InvestPaymentMethodType | null
  handlePaymentMethodChange: (paymentMethod: InvestPaymentMethodType | null) => void
  handleOTPTrigger: (payload: BuyMasterPayload) => void
  handleRefetchPaymentMethods: () => void
  otpState: OrderOtpState | null
  installedUpiApps: InstalledUpiApp[] | null
  requestUpiIntents: () => void
}

export const BuyContext = createContext<BuyContextType | undefined>(undefined)

export const useBuyContext = () => {
  const context = useContext(BuyContext)
  if (!context) {
    throw new Error('useBuyContext must be used within a BuyProvider')
  }
  return context
}
